var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNetworkLimiterDisabledMain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 61,
    viewBox: "0 0 77 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.7804 55.5174C41.4904 55.5174 43.6874 53.3204 43.6874 50.6103C43.6874 47.9002 41.4904 45.7033 38.7804 45.7033C36.0703 45.7033 33.8733 47.9002 33.8733 50.6103C33.8733 53.3204 36.0703 55.5174 38.7804 55.5174ZM38.7804 60.4244C44.2005 60.4244 48.5945 56.0305 48.5945 50.6103C48.5945 45.1901 44.2005 40.7962 38.7804 40.7962C33.3602 40.7962 28.9662 45.1901 28.9662 50.6103C28.9662 56.0305 33.3602 60.4244 38.7804 60.4244Z",
    fill: "#5C4E7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.6985 16.5062C67.223 6.59659 53.8712 0.424438 39.0778 0.424438C23.6725 0.424438 9.83049 7.11773 0.30127 17.7549L4.17885 21.2262C12.7551 11.6529 25.2129 5.62901 39.0775 5.62901C52.3916 5.62901 64.4083 11.184 72.9363 20.1026L76.6985 16.5062Z",
    fill: "#5C4E7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.1742 23.6989C61.5938 15.7712 50.9123 10.8335 39.0775 10.8335C26.7534 10.8335 15.6799 16.188 8.0565 24.6976L11.9341 28.169C18.6045 20.7232 28.2938 16.038 39.0773 16.038C49.4328 16.038 58.7791 20.3586 65.412 27.2954L69.1742 23.6989Z",
    fill: "#5C4E7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.6501 30.8915C55.9647 24.9457 47.9536 21.2424 39.0775 21.2424C29.8344 21.2424 21.5293 25.2583 15.8118 31.6405L19.6893 35.1118C24.4539 29.7934 31.3748 26.4469 39.0773 26.4469C46.4741 26.4469 53.15 29.533 57.8878 34.4879L61.6501 30.8915Z",
    fill: "#5C4E7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.1259 38.0841C50.3357 34.1202 44.9949 31.6513 39.0775 31.6513C32.9155 31.6513 27.3788 34.3285 23.5671 38.5833L27.4446 42.0546C30.3034 38.8637 34.4558 36.8558 39.0773 36.8558C43.5154 36.8558 47.521 38.7075 50.3637 41.6805L54.1259 38.0841Z",
    fill: "#5C4E7E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetworkLimiterDisabledMain);
export default __webpack_public_path__ + "static/media/networkLimiterDisabledMain.3c9f3cf162b9a01feabac338ad4e1bc1.svg";
export { ForwardRef as ReactComponent };